var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationBenchItem.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationBenchItem = function (_React$Component) {
  (0, _inherits2.default)(FormationBenchItem, _React$Component);

  var _super = _createSuper(FormationBenchItem);

  function FormationBenchItem() {
    var _this;

    (0, _classCallCheck2.default)(this, FormationBenchItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.generateIconKey = function (lastName, jerseyNumber, event, index) {
      return lastName + "_" + jerseyNumber + "_" + event + "_" + index;
    };

    return _this;
  }

  (0, _createClass2.default)(FormationBenchItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          away = _this$props.away,
          even = _this$props.even,
          player = _this$props.player,
          onPress = _this$props.onPress,
          href = _this$props.href,
          itemStyle = _this$props.itemStyle,
          NavWrapper = _this$props.NavWrapper;
      if (!player) return null;
      var jerseyNumber = player.jerseyNumber,
          firstName = player.firstName,
          lastName = player.lastName,
          nickName = player.nickName,
          events = player.events;
      return _react.default.createElement(_Touchable.default, {
        onPress: onPress,
        href: href,
        NavWrapper: NavWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 24,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Row, {
        flexing: true,
        my: 1,
        p: 2,
        borderX: itemStyle ? itemStyle.borderX : 1,
        borderY: itemStyle ? itemStyle.borderY : 1,
        borderColor: "border.main",
        bg: even ? (0, _get.default)(itemStyle, 'evenBg') : (0, _get.default)(itemStyle, 'oddBg'),
        reverseRow: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Text, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 21
        }
      }, jerseyNumber), _react.default.createElement(_Basic.Text, {
        numberOfLines: 1,
        mx: 2,
        grow: true,
        textAlign: away ? 'right' : 'left',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 21
        }
      }, nickName || (firstName || '') + " " + lastName), events ? events.map(function (event, index) {
        switch (event) {
          case 'YELLOW_CARD':
            return _react.default.createElement(_FontelloIcon.default, {
              key: lastName + "_" + jerseyNumber + "_" + event,
              name: "card",
              color: "YELLOW_CARD",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 44,
                columnNumber: 43
              }
            });

          case 'RED_CARD':
            return _react.default.createElement(_FontelloIcon.default, {
              key: lastName + "_" + jerseyNumber + "_" + event,
              name: "card",
              color: "red",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 52,
                columnNumber: 43
              }
            });

          case 'YELLOW_RED_CARD':
            return _react.default.createElement(_Basic.Column, {
              key: lastName + "_" + jerseyNumber + "_" + event,
              position: "relative",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 60,
                columnNumber: 43
              }
            }, _react.default.createElement(_react.default.Fragment, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 64,
                columnNumber: 47
              }
            }, _react.default.createElement(_FontelloIcon.default, {
              name: "card",
              color: "YELLOW_CARD",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 65,
                columnNumber: 51
              }
            }), _react.default.createElement(_FontelloIcon.default, {
              name: "card-yellow-red",
              color: "RED_CARD",
              position: "absolute",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 66,
                columnNumber: 51
              }
            })));

          case 'GOAL':
            return _react.default.createElement(_FontelloIcon.default, {
              key: _this2.generateIconKey(lastName, jerseyNumber, event, index),
              name: "goal",
              color: "black",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 76,
                columnNumber: 43
              }
            });

          default:
            return null;
        }
      }) : null));
    }
  }]);
  return FormationBenchItem;
}(_react.default.Component);

FormationBenchItem.propTypes = {
  away: _propTypes.default.bool,
  player: _propTypes.default.object,
  NavWrapper: _propTypes.default.func
};
FormationBenchItem.defaultProp = {
  away: false
};
var _default = FormationBenchItem;
exports.default = _default;